module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/pen-ruler-8ff6d68ff5798773499d4f1b995c5737.svg";